import React, { Component } from 'react';
import Search from '../../../../common/components/search-text/search-text';
import Button from '../../../../home/button-classic/button-classic';
import { connect } from "react-redux";
import ACTIONS from '../../../../common/action_constant'
// import { toPascalCase } from "../../../utils/validate";

import Delete from '../../../../assets/images/delete.svg';
import Edit from '../../../../assets/images/edit.svg'
import { getCookie } from '../../../../utils/cookies';
import AddInventory from './add_inventory';
import { withRouter } from 'react-router-dom';
import { COROMANDEL_COMPANY_IDS, getEmail, getUserId } from '../../../../utils/common';
import { getItemFromSessionStorage } from '../../../../utils/sessionStorage';
// import { AWL_COMPANY_IDS } from '../../../../../utils/common';
import Select from 'react-select';

class InventoryMaster extends Component {

    constructor(props) {
        super(props);
        this.state = {
            search: '',
            offset: 0,
            limit: 20,
            isOpen: false,
            editData: '',
            selectedBranch: null,
            selectedBranchCode: ''
        }
    }

    componentDidMount() {
        this.getInventoryMaster();
        this.fetchDepotName();
    }

    fetchDepotName = () => {
        const { dispatch, companyId } = this.props;


        dispatch({
            type: ACTIONS.PLANTS.GET_DEPO_NAME,
            queryString: `?companyId=${companyId}`
        })


        dispatch({
            type: ACTIONS.PLANTS.GET_PLANTS_DEPOTS,
            data: `?companyId=${companyId}`
        })
    }

    getInventoryMaster = () => {
        const { dispatch, companyId } = this.props;
        const { search, offset, limit,selectedBranchCode } = this.state;
        
        let queryString = `?company_id=${companyId}&limit=${limit}&offSet=${offset}`
        if(!!search){
            queryString = queryString +`&search=${search}`
        }
        if(!!selectedBranchCode){
            queryString = queryString + `&branchCode=${selectedBranchCode}`
        }

        dispatch({
            type: ACTIONS.PLANTS.GET_INVENTORY_MASTER,
            queryString
        })
    }

    toggleAdd = () => {
        this.setState(p => ({ isOpen: !p.isOpen, editData: '' }))
    }

    onSave = (data) => {
        const { dispatch } = this.props;
        const isCoroMandel = COROMANDEL_COMPANY_IDS.includes(this.props.companyId);
        // data.master_type = 10;
        // data.new_flag = true;
        // data.user_email = getEmail();
        // data.user_id = getUserId();
        if(isCoroMandel){
            delete data.carpet_area_in_sqft;
            delete data.zone;
            delete data.storage_capacity_in_mt;
            delete data.total_area_in_sqft
        }

        dispatch({
            type: ACTIONS.PLANTS.ADD_INVENTORY_MASTER,
            data,
            onSuccess: () => {
                this.setState({ isOpen: false }, this.getInventoryMaster);
            }
        })
    }

    onUpdate = (data) => {
        const prev = getItemFromSessionStorage('InventoryIn');
        // prev.update_flag = true;
        // prev.user_email = getEmail();
        // prev.user_id = getUserId();

        const { dispatch } = this.props;

        // data.master_type = 10;
        // data.update_flag = true;
        // data.user_email = getEmail();
        // data.user_id = getUserId();
        // data.previous_data = prev;
        const isCoroMandel = COROMANDEL_COMPANY_IDS.includes(this.props.companyId);
        if(isCoroMandel){
            delete data.carpet_area_in_sqft;
            delete data.zone;
            delete data.storage_capacity_in_mt;
            delete data.total_area_in_sqft
        }

        dispatch({
            type: ACTIONS.PLANTS.UPDATE_INVENTORY_MASTER,
            data,
            onSuccess: () => {
                this.setState({ isOpen: false, editData: '' }, this.getInventoryMaster);
            }
        })
    }

    editMC = (d) => this.setState({ editData: d, isOpen: true })

    deleteMC = (d) => {
        const { dispatch } = this.props;

        dispatch({
            type: ACTIONS.PLANTS.DELETE_INVENTORY_MASTER,
            queryString: `?company_id=${d.company_id}&branch_code=${d.branch_code}&inventoryId=${d.inventory_id}`,
            onSuccess: this.getInventoryMaster
        })
    }

    previous = () => {
        if (this.state.offset >= this.state.limit) {
            this.setState(p => ({ offset: p.offset - p.limit }), this.getInventoryMaster)
        }
    }

    next = () => {
        this.setState(p => ({ offset: p.offset + p.limit }), this.getInventoryMaster)
    }

    changeHandler = (v) => this.setState({ search: v })

    onSearch = () => {
        this.setState({ offset: 0 }, this.getInventoryMaster)
    }

    clearFilterOnCancel = () => {
        this.setState({ search: '', offset: 0 }, this.getInventoryMaster)
    }

    handleOnClickForAuditBtn = () => {
        this.props.history.push(`/auditScreen/${this.props.companyId}/10`)
    }

    render() {

        const { plantsDepots } = this.props;
        const { DepotName, inventoryMaster ,plantsDepotsList } = plantsDepots;
           const branchOptions = (plantsDepotsList || []).map(d => ({
            label: d.branch_name,
            value: d.branch_id,
            code: d.branch_code
        }));

        const isCoroMandel = COROMANDEL_COMPANY_IDS.includes(this.props.companyId);

        return (
            <div className='location-network'>

                <div style={{ paddingBottom: '15px' }}>
                    <Search
                        id="search"
                        value={this.state.search}
                        placeholder="Search..."
                        changeHandler={this.changeHandler}
                        click={this.onSearch}
                        canClear={this.state.search !== ''}
                        handleClearFilter={this.clearFilterOnCancel}
                    />
                    <div style={{ width: 200, display: 'inline-block', marginLeft: 8, }}>
            <Select
                placeholder="Select Branch"
                isClearable
                options={(this.props.plantsDepots?.plantsDepotsList || []).map(d => ({
                    label: d.branch_name,
                    value: d.branch_id,
                    code: d.branch_code
                }))}
                value={
                    (this.props.plantsDepots?.plantsDepotsList || [])
                        .map(d => ({
                            label: d.branch_name,
                            value: d.branch_id,
                            code: d.branch_code
                        }))
                        .find(b => b.value === this.state.selectedBranch) || null
                }
                getOptionLabel={opt => opt.label + (opt.code ? ` - ${opt.code}` : '')}
                onChange={(opt) => {
                    this.setState(
                        {
                            selectedBranch:  opt ? opt.value : null,
                            selectedBranchCode: opt ? opt.code : '',
                            offset: 0
                        },
                        this.getInventoryMaster
                    );
                }}
            />
        </div>

                    <Button value='+ Inventory Master' click={this.toggleAdd} />
                     <button className="button-classic" onClick={this.handleOnClickForAuditBtn}>Audit</button>

                </div>

                <table className='chain-details-section' style={{ border: 'none', borderCollapse: 'collapse' }}>

                    <thead>
                        <tr className='list-section header' style={{ border: 'none' }}>
                            <td className='tabel-header vol-th' style={{ border: 'none' }}>Branch Name</td>

                            {isCoroMandel ? (
                                <>
                                    <td className='tabel-header vol-th' style={{ border: 'none' }}>Branch Code</td>
                                    <td className='tabel-header vol-th' style={{ border: 'none' }}>Material Number</td>
                                    <td className='tabel-header vol-th' style={{ border: 'none' }}>Storage Location</td>
                                    <td className='tabel-header vol-th' style={{ border: 'none' }}>Batch Number</td>
                                </>
                            ) : (
                                <>
                                    <td className='tabel-header vol-th' style={{ border: 'none' }}>Total Area in sqft</td>
                                    <td className='tabel-header vol-th' style={{ border: 'none' }}>Carpet Area in sqft</td>
                                    <td className='tabel-header vol-th' style={{ border: 'none' }}>Storage Capacity in mt</td>
                                </>
                            )}

                            <td className='tabel-header vol-th' style={{ border: 'none' }}>Actions</td>
                        </tr>
                    </thead>

                    <tbody>
                        {(inventoryMaster || []).map((mc, i) => (
                            <tr key={i} className='list-section content' style={{ border: 'none' }}>

                                <td className='tabel-header vol-td' style={{ border: 'none' }}>{mc.branch_name}</td>

                                {isCoroMandel ? (
                                    <>
                                        <td className='tabel-header vol-td' style={{ border: 'none' }}>{mc.branch_code}</td>
                                        <td className='tabel-header vol-td' style={{ border: 'none' }}>{mc.material_number}</td>
                                        <td className='tabel-header vol-td' style={{ border: 'none' }}>{mc.storage_location}</td>
                                        <td className='tabel-header vol-td' style={{ border: 'none' }}>{mc.batch_number}</td>
                                    </>
                                ) : (
                                    <>
                                        <td className='tabel-header vol-td' style={{ border: 'none' }}>{mc.total_area_in_sqft}</td>
                                        <td className='tabel-header vol-td' style={{ border: 'none' }}>{mc.carpet_area_in_sqft}</td>
                                        <td className='tabel-header vol-td' style={{ border: 'none' }}>{mc.storage_capacity_in_mt}</td>
                                    </>
                                )}

                                <td className='tabel-header vol-act' style={{ border: 'none' }}>
                                    <div className='action-icon' style={{ backgroundImage: `url(${Edit})` }} onClick={() => this.editMC(mc)} />
                                    <div className='action-icon' style={{ backgroundImage: `url(${Delete})` }} onClick={() => this.deleteMC(mc)} />
                                </td>

                            </tr>
                        ))}
                    </tbody>

                </table>

                <div className="submit-section-pagination">
  <div className="next">
    <Button value="Next" click={this.next} />
  </div>

  <div className="pre">
    <Button value="Previous" click={this.previous} />
  </div>
</div>

                {this.state.isOpen &&
                    <AddInventory
                        toggleAdd={this.toggleAdd}
                        onSave={this.onSave}
                        companyId={this.props.companyId}
                        editData={this.state.editData}
                        onUpdate={this.onUpdate}
                        fetchDepotName={DepotName}
                        plantsList={plantsDepotsList}
                    />
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        plantsDepots: state.plantsDepots|| [],      
        home: state.home,
        fetchDepotName: state.fetchDepotName
    };
};

export default connect(mapStateToProps)(withRouter(InventoryMaster));

